import { Component, OnInit } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, AuthService } from 'app/core/core.module';
import { environment } from 'environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { alert, confirm } from 'devextreme/ui/dialog';
import { ContributionAccountAttachment } from 'app/core/model/entity-model';

@Component({
    selector: 'app-account-detail',
    templateUrl: './account-detail.component.html',
    styleUrls: ['./account-detail.component.css'],
    standalone: false,
})
export class AccountDetailComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    account: any;
    accountId: number;
    routerOption: string;
    canEdit = false;
    serviceName = environment.serviceName;
    uploadHeaders: any;
    attachments: any;

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, public appInfo: AppInformationService, private auth: AuthService) {}

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();
        this.uploadHeaders = { Authorization: 'Bearer ' + this.auth.currentUser.jwtToken };
        if (this.routerOption === 'new') {
            this.account = this.uow.contributionAccounts.createEntity();
            this.account.active = true;
            this.account.displayOrder = 1000;
        } else {
            await this.getData();
        }
        this.canEdit = this.auth.hasRole('Accounts:Admin');
        this.appInfo.pleaseWaitHide();
    }

    async getData() {
        this.account = await this.uow.getEntityById('ContributionAccounts', this.accountId, 'attachments');
        this.attachments = this.account.attachments.filter((x) => {
            if (!x.deleted) return x;
        });
    }

    async save() {
        await this.uow.commit();
        this.result.next({ result: true });
        this.modalRef.hide();
    }

    cancel() {
        this.uow.rollback();
        this.modalRef.hide();
    }

    async uploadStarted(e) {
        this.appInfo.pleaseWaitShow();
    }

    async uploaded(e) {
        if (e && e.request && e.request.responseText) {
            const fileResponses = JSON.parse(e.request.responseText);
            const attachment = this.uow.contributionAccountAttachments.createEntity({
                name: fileResponses.name,
                filename: fileResponses.link,
                contributionAccountId: this.account.id,
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
            }) as ContributionAccountAttachment;
        }
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async uploadError(e) {
        await alert('An error occurred while attempting to upload the file(s)', `${this.appInfo.settings.church}`);
        this.appInfo.pleaseWaitHide();
    }

    openAttachment(attachment) {
        const fullPath = 'https://peccerium.blob.core.windows.net/';
        let fileName = attachment.filename.replace(fullPath, '');
        const fileNameURI = encodeURIComponent(fileName);
        const path = fullPath + fileNameURI;
        window.open(path, '_blank');
    }

    downloadAttachment(attachment) {
        console.log(attachment);
        const url = `${environment.serviceName}/file/downloadAttachment/?id=${attachment.id}`;
        window.open(url, '_blank');
    }

    removeAttachment(e, attachment) {
        e.preventDefault();
        attachment.deleted = new Date();
        this.getData();
    }
}
